import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import '../../../css/Announcement/AnnouncementDetails.css';
import crane from '../../../Assets/Announcement/Assets-Desktop/crane.svg';
import announcement from '../../../Assets/Announcement/Assets-Desktop/megaphonesvg.svg';
import arrowrightred from '../../../Assets/Announcement/Assets-Desktop/arrow_right.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { ALLANNOUNCEMENTSDETAILS_ENDPOINT, DOCUMENT_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { useDispatch } from 'react-redux';
import { successLoader, } from '../../../Redux/_actions/loader.action';
import Cookies from 'cookies-js';

const AnnouncementDetails = props => {
    const dispatch = useDispatch();
    const paramObj = useParams();
    const [announcementDetails, setAnnouncementDetails] = useState([]);
    const [PDFValue, setPDFValue] = useState(false);
    const [PDFText, setPDFText] = useState(false);
    const pdfURL = utilityBaseURL + DOCUMENT_ENDPOINT + "?documentPath=";
    const showPDF = () => {
        const testAccess = Cookies.get('_msAL');
        //start loader
        dispatch(successLoader(false));
        var oReq = new XMLHttpRequest();
        var URLToPDF = pdfURL + announcementDetails.attachment;
        oReq.open("GET", URLToPDF, true);
        oReq.setRequestHeader("Authorization", 'Bearer' + ` ${testAccess}`);
        oReq.responseType = "blob";
        oReq.onload = function () {
            const file = new Blob([oReq.response], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            //end loader
            dispatch(successLoader(true));
            window.open(fileURL, "_blank");
        };
        oReq.send();
    }
    useEffect(() => {

        const { announcementId } = paramObj;
        ApiCall(
            'GET',
            utilityBaseURL + ALLANNOUNCEMENTSDETAILS_ENDPOINT + `?announcementId=${announcementId}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                } else {
                    setAnnouncementDetails(apiData[0]);
                    setPDFValue(apiData[0]?.attachment?.length > 0);
                    setPDFText(apiData[0]?.attachment?.length > 0 && apiData[0]?.text?.length > 0);
                }
            }
        });
    }, []);
    return (
        <div class="andoutfull" >
            <MetaDecorator title={TitleDescription.announcementDetailsPageTitle} description={TitleDescription.announcementDetailsPageDescription} />
            <Header tilesFetched={() => { }} />
            <div class="andfull">
                <div id="andbox1">
                    <nav className="navbar " class="andnavbar">
                        <div className="andanavbarname">
                            <small id="andnavc">Announcement Detail</small>
                        </div>
                    </nav>
                    <hr class="hr1" />
                    <div class="notification">
                        <small id="notification1">
                            {announcementDetails?.announcementCategory}
                        </small>
                    </div>
                    <div class="maincard">
                        <div class="andnavcard" >
                            <div class="terminaldiv">
                                <img src={crane} class="mr-3 mb-1" id="terminalicon" alt="" loading="lazy" />
                                <small id="terminalname">Terminal</small>
                            </div>
                            <hr class="hr2" />
                            <div class="terminaldiv1">
                                {(announcementDetails?.ports?.map((name, index) => {
                                    return (
                                        <div class="formatcontent">
                                            <div class="contantindex">{index + 1}.</div>
                                            <div class="contant" >{name?.portName?.split(':')[0]}</div>
                                        </div>
                                    );
                                }))}
                            </div>
                        </div>
                        {PDFText ?
                            <div class="navcardPart1pdftextouter" >
                                <div class="annterminaldiv">
                                    <img src={announcement} class="mr-3" id="terminalicon" alt="" loading="lazy" />
                                    <small id="terminalname">Announcement</small>
                                </div>
                                <hr class="hr2" />
                                <div class="announcementdivpdftext">
                                    <div class="contant">{announcementDetails?.text}</div>
                                    <div class="contantpdfup">Please refer below pdf for more details:</div>
                                    <div class="viewpdfouterdiv" onClick={showPDF} >
                                        <a id="viewPdf"
                                            target="_blank"
                                        >View PDF</a>
                                        <a
                                            target="_blank">
                                            <img src={arrowrightred} class="" id="arrowpdficon" alt="" loading="lazy" /></a>
                                    </div>
                                </div>
                            </div>
                            :
                            (PDFValue ?
                                <div class="viewnavcardPart1pdf" >
                                    <div class="annterminaldiv">
                                        <img src={announcement} class="mr-3" id="terminalicon" alt="" loading="lazy" />
                                        <small id="terminalname">Announcement</small>
                                    </div>
                                    <hr class="hr2" />
                                    <div class="viewannouncementdiv">
                                        <div class="viewpdfouterdiv" onClick={showPDF}>
                                            <a id="viewPdf"
                                                target="_blank"
                                            >View PDF</a>
                                            <a>
                                                <img src={arrowrightred} class="" id="arrowpdficon" alt="" loading="lazy" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div class="navcardPart1" >
                                    <div class="annterminaldiv">
                                        <img src={announcement} class="mr-3" id="terminalicon" alt="" loading="lazy" />
                                        <small id="terminalname">Announcement</small>
                                    </div>
                                    <hr class="hr2" />
                                    <div class="announcementdiv">
                                        <div class="contant" >
                                            {announcementDetails?.text}
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default AnnouncementDetails;